import { useParams } from 'react-router-dom';
import {
    StepsViewModeEnum,
    StepsViewModeType,
} from '@shared/Enums/StepsViewModeEnum';
import ProtectedRoute from './ProtectedRoute';

interface StepsConditionalProtectedRouteProps {
    children: React.ReactElement;
}

const StepsConditionalProtectedRoute: React.FC<
    StepsConditionalProtectedRouteProps
> = ({ children }) => {
    const { viewMode } = useParams<{ viewMode: StepsViewModeType }>();

    if (viewMode === StepsViewModeEnum.PROJECT) {
        return <ProtectedRoute>{children}</ProtectedRoute>;
    }

    return <>{children}</>;
};

export default StepsConditionalProtectedRoute;
